<template>
  <div class="bid-left-top">
    <div class="place-text">Closes in :</div>
    <div class="spaceLeft">
      <div class="bid-time-min spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{ dd }}</div>
          <div class="bid-time-text-sm">DAY</div>
        </div>
      </div>
      <span class="bid-time-spot">:</span>
      <div class="bid-time-sec spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{ PrefixInteger(hh) }}</div>
          <div class="bid-time-text-sm">HOR</div>
        </div>
      </div>
      <span class="bid-time-spot">:</span>
      <div class="bid-time-sec spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{ PrefixInteger(mm) }}</div>
          <div class="bid-time-text-sm">MIN</div>
        </div>
      </div>
      <span class="bid-time-spot">:</span>
      <div class="bid-time-sec spaceCenter">
        <div class="bid-time-text">
          <div class="bid-time-text-big">{{ PrefixInteger(ss) }}</div>
          <div class="bid-time-text-sm">SEC</div>
        </div>
      </div>
    </div>
    <div class="place-text-2" v-if="!needHideTips">
      {{
        hasBid
          ? "You have already bid on this lot."
          : "You haven't bid on this lot yet."
      }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    hasBid: {
      type: Boolean
    },
    needHideTips: {
      type: Boolean
    },
    closeTime:{
      type: [String,Number]
    }
  },
  data() {
    return {
      timmer: null,
      targetTime: null,
      time_block: 1000 * 60 * 60 * 24,
      time1: "",
      dd: "0",
      HH: "0",
      mm: "0",
      ss: "0"
    };
  },
  computed: {},
  methods: {
    countTime() {
      let time2 = new Date().getTime();
      this.targetTime = (this.time1 - time2);

      var h, m, s, d;
      if (this.targetTime > 1) {
        d = Math.floor(this.targetTime/(1000*60*60*24)),
        h = Math.floor(this.targetTime/(1000*60*60)%24);
        m = Math.floor(this.targetTime/(1000*60)%60);
        s = Math.floor(this.targetTime/1000%60);
        this.targetTime = this.targetTime - 1000;
        this.dd = d;
        this.hh = h;
        this.mm = m;
        this.ss = s;
      } else {
        this.targetTime = this.time_block;
        this.dd = 0;
        this.hh = 0;
        this.mm = 0;
        this.ss = 0;
      }
      this.timmer = window.setTimeout(this.countTime, 1000);
    },
    PrefixInteger(num) {
      return +num < 10 ? "0" + num : num;
    },
    setTime() {
      this.time1 = new Date(this.closeTime).getTime();
      this.countTime();
    }
  },
  created() {
    if(this.closeTime){
      this.setTime();
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.timmer);
  },
  watch:{
    closeTime(newVal){
      if(newVal){
        this.setTime();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.bid-left-top {
  margin-top: 0.16rem;
}
.bid-time-min,
.bid-time-sec {
  width: 0.84rem;
  height: 0.8rem;
  // background: rgba(255, 255,255, .08);
  box-shadow: 0 0.02rem 0.4rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 0.04rem;
  text-align: center;
  background:url("../../../../../assets/image/placeBid/countdown-bg.svg") no-repeat center/cover;
}
.bid-time-text-big {
  font-size: 0.28rem;
  font-weight: bold;
  color: #3172fd;
  line-height: 0.36rem;
  letter-spacing: 0.01rem;
  margin-bottom: 0.1rem;
}
.bid-time-text-sm {
  font-size: 0.16rem;
  font-weight: 500;
  color: #929dad;
  line-height: 0.19rem;
}
.bid-time-spot {
  font-size: 0.24rem;
  font-weight: bold;
  color: rgba(31, 31, 31, 1);
  margin: 0 0.12rem;
}
.place-text {
  font-size: 0.2rem;
  font-weight: 500;
  color: rgba(255, 255, 255, .7);
  line-height: 0.24rem;
  margin-bottom: 0.08rem;
}
.place-text-2 {
  text-align: center;
  font-size: 0.22rem;
  font-weight: 500;
  color: #929dad;
  line-height: 0.32rem;
  margin-top: 0.24rem;
}
</style>
